import { createContext, PropsWithChildren, useContext } from 'react';

import { NoDataReason } from '@cast/types';

import {
  TopMostExpensiveGroup,
  TopMostExpensiveGroupDatapoint,
} from 'types/top-items';

import { useTopMostExpensiveWorkloads } from './_hooks/useTopMostExpensiveWorkloads';

type NetworkCostOverTimeContextValue = {
  isLoading: boolean;
  noDataReason?: NoDataReason;
  error?: unknown;
  refetch?: () => void;
  topMostExpensiveWorkloads: TopMostExpensiveGroup[];
  datapoints: TopMostExpensiveGroupDatapoint;
};

const WorkloadsNetworkCostOverTimeContext =
  createContext<NetworkCostOverTimeContextValue>({} as never);

export const WorkloadsNetworkCostOverTimeProvider = ({
  children,
}: PropsWithChildren) => {
  const {
    data: topMostExpensiveWorkloads,
    datapoints: topMostExpensiveWorkloadDatapoints,
    isLoading,
    noDataReason,
    error,
    refetch,
  } = useTopMostExpensiveWorkloads();

  return (
    <WorkloadsNetworkCostOverTimeContext.Provider
      value={{
        isLoading,
        noDataReason,
        error,
        refetch,
        topMostExpensiveWorkloads,
        datapoints: topMostExpensiveWorkloadDatapoints,
      }}
    >
      {children}
    </WorkloadsNetworkCostOverTimeContext.Provider>
  );
};

export const useWorkloadsNetworkCostOverTime = () => {
  return useContext(WorkloadsNetworkCostOverTimeContext);
};
